"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ContactCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="contact-cta" ref={ref} className="relative pt-24 pb-40 px-6 bg-background !h-[325px] hidden sm:block">
      <div className="max-w-4xl mx-auto text-center">
        <div className={`space-y-8 transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="font-display font-bold text-foreground leading-tight ![margin:-50px_0px_32px_0px] !text-4xl">Start Your Journey with New Mavericks</h2>
          <p className="text-white max-w-2xl mx-auto !text-2xl">Call: +1-323-742-2225 or email: support@newmavericks.com</p>

          <div className="pt-4">
            <Link to="https://calendly.com/newmavericks/" newTab>
              <Button size="lg" className="text-sm inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive text-primary-foreground shadow-xs h-[60px] rounded-md px-9 has-[>svg]:px-6 group relative overflow-hidden transition-all duration-[80ms] ease-[var(--ease-spring)] !w-[270px] !text-[27px] !bg-[hsl(172,66%,50%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90 hover:scale-[1.02] active:scale-100">Schedule Call</Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}